/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_cookies = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.onready = function() {

		/*
		Listeners
		*/
		$(document).on('click','.js-cookies-yes',function() {
			specific_cookies.yes();
			popup.close();
		});

		$(document).on('click','.js-cookies-no',function() {
			specific_cookies.no();
			popup.close();
		});

		// $(document).on('click','.js-cookie-popup-open',function() {
		// 	popup.open(1,1,'cookies');
		// });

		if(_cookie == 'yes') {
			specific_cookies.yes();
		} else {
			specific_cookies.no();
		}
		
	};

	/*
	Yes
	*/
	this.yes = function() {

		/*
		Celebrus: Yes
		*/
		_marcsenseretain_active = 1;

		// if(typeof celebrusoptOutStatus !== 'undefined') {

			if(typeof celebrusoptIn === 'function') {
				window.celebrusoptIn();
			}
			// sessionStorage.setItem("celebrus", "on");

			/*
			Set cookie session
			*/
			specific_cookies.set('yes');

		// }

	};

	/*
	No
	*/
	this.no = function() {

		/*
		Celebrus: No
		*/
		_marcsenseretain_active = 0;

		/*if(typeof celebrusoptOutStatus !== 'undefined') {*/

			if(typeof celebrusoptOut === 'function') {
				window.celebrusoptOut();
			}
			// sessionStorage.setItem("celebrus", "off");

			specific_cookies.set('no');

		/*}*/

	};

	this.set = function(
		w
	) {

		$.ajax({
			url: globalUrl + '/a/a/setcookie/' + w,
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {
			
		})
		.always(function() {
		});

	};

		
}).apply(specific_cookies); 